var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modules && !!_vm.modules['invoices'])?_c('router-link',{staticClass:"btn btn-link ml-auto",attrs:{"to":"/app/bookings/balances"}},[_c('fa-icon',{attrs:{"icon":"coins"}}),_vm._v(" Balances ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }